export const START_FORM_URL = `start-form/:processDefinitionKey`;
export const START_FORM_WITH_CONTENT_URL = `start-form/:processDefinitionKey/:nodeId`;
export const TASK_FORM_URL = `task-form/:taskId`;
export const TASK_ENDED_URL = 'task-ended/:taskId';
export const TASK_NOT_FOUND_IN_TIME_URL = `task-not-found-in-time/:taskId`;
export const TASK_NOT_FOUND_URL = 'task-not-found/:taskId';
export const WORKFLOW_NOT_FOUND_URL = 'workflow-not-found/:processInstanceId';
export const PROCESS_ENDED_URL = `process-ended/:processInstanceId`;
export const TASK_NOT_AUTHORIZED_URL = `task-no-permission/:taskId`;
export const WORKFLOW_DETAILS_URL = `workflow-details/:processInstanceId`;
